import { AxiosError } from 'axios'
import { Alerts } from '@src/components/Alerts'


export const delErrorCheck = (err:AxiosError) => {
    if (err.response?.status === 409) Alerts.error('This cannot be deleted - it is still being used.')
    else throw err
}